module.exports = __webpack_public_path__ + "img/7-1_03.cd06dea0.jpg";